import $ from 'jquery';
import flatpickr from 'flatpickr/dist/flatpickr.min.js';
import ShortcutButtonsPlugin from 'shortcut-buttons-flatpickr/dist/shortcut-buttons-flatpickr.min.js';

$.addInit(function(context){
	var base = '.b-datapicker';

	var localeDatapicker = document.documentElement.lang || 'ru';

	var messagesDatapicker = {
		'ru': {
			weekdays: {
				shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
			},
			months: {
				shorthand: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
				longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			},
			reset: 'Сбросить дату'
		},
		'en': {
			weekdays: {
				shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
				longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			},
			months: {
				shorthand: ['Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				longhand: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			},
			reset: 'Reset date'
		},
		'ua': {
			weekdays: {
				shorthand: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				longhand: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Субота'],
			},
			months: {
				shorthand: ['Січ', 'Лют', 'Березень', 'Апр', 'Травень', 'Червень', 'Липень', 'Сер', 'Вер',' Жов', 'Лис', 'Дек'],
				longhand: ['Січня', 'Лютого', 'Березня', 'Квітня', 'Травня', 'Червня', 'Липня', 'Серпня', 'Вересня', 'Жовтня', 'Листопада', 'Грудня'],
			},
			reset: 'Скинути дату'
		},
		'lt': {
			weekdays: {
				shorthand: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pt', 'Št'],
				longhand: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
			},
			months: {
				shorthand: ['sau', 'vas', 'kov', 'bal', 'geg', 'bir', 'lie', 'rgp', 'rgs', 'spl', 'lap', 'grd'],
				longhand: ['sausis', 'vasaris', 'kovas', 'balandis', 'gegužė', 'birželis', 'liepa', 'rugpjūtis', 'rugsėjis', 'spalis', 'lapkritis', 'gruodis'],
			},
			reset: 'Reset Data'
		},
		'lv': {
			weekdays: {
				shorthand: ['Sv', 'P', 'Ot', 'Tr', 'Ce', 'Pk', 'Se'],
				longhand: ['Svētdiena', 'Pirmdiena', 'Otrdiena', 'Trešdiena', 'Ceturtdiena', 'Piektdiena', 'Sestdiena'],
			},
			months: {
				shorthand: ['janv', 'febr', 'marts', 'apr', 'maijs', 'jūn', 'jūl', 'aug', 'sept', 'okt', 'nov', 'dec'],
				longhand: ['janvāris', 'februāris', 'marts', 'aprīlis', 'maijs', 'jūnijs', 'jūlijs', 'augusts', 'septembris', 'oktobris', 'novembris', 'decembris'],
			},
			reset: 'Atiestatīt Datumu'
		},
		'st': {
			weekdays: {
				shorthand: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
				longhand: ['Pühapäev', 'Esmaspäev', 'Teisipäev', 'Kolmapäev', 'Neljapäev', 'Reede', 'Laupäev',],
			},
			months: {
				shorthand: ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sep', 'okt', 'nov', 'dets'],
				longhand: ['jaanuar', 'veebruar', 'märts', 'aprill', 'mai', 'juuni', 'juuli', 'august', 'september', 'oktoober', 'november', 'detsember'],
			},
			reset: 'Lähtesta Kuupäev'
		}
	};

	var messages = messagesDatapicker[localeDatapicker] || messagesDatapicker['en'];

	$(base, context).each(function(){
		var component = $(this);
		var input = component.find(base + '-input');

		input.flatpickr({
			// altInput: true, 
			allowInput: true,
			dateFormat: 'd.m.Y',
			monthSelectorType: 'static',
			yearSelectorType: 'static',
			locale: {
				firstDayOfWeek: 1,
				weekdays: messages.weekdays,
				months: messages.months,
			},
			plugins: [
				ShortcutButtonsPlugin({
					button: {
						label: messages.reset,
					},
					onClick: function(index, fp) {
						fp.clear();
						fp.close();
					}
				})
			]
		});

		input.on('focus', function() {
			$(this).blur();
		});
	});
});
